/* Slumbr Sleep Clinic™ — shared client behavior
   Extracted from inline <script> in docs/reference-site/index.html.
   Loaded once via layout/theme.liquid.

   Provides:
     - mobile drawer toggle
     - IntersectionObserver scroll reveal
     - FAQ / generic accordion toggle
     - product page buy-option (once-off vs subscribe) switch + qty stepper
*/
(function () {
  'use strict';

  // ---- mobile drawer ----
  const hamburger = document.querySelector('.hamburger');
  const drawer = document.querySelector('.drawer');
  if (hamburger && drawer) {
    const setOpen = (open) => {
      drawer.classList.toggle('open', open);
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    };
    hamburger.addEventListener('click', () => setOpen(!drawer.classList.contains('open')));
    drawer.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setOpen(false)));
    const drawerClose = drawer.querySelector('.drawer-close');
    if (drawerClose) drawerClose.addEventListener('click', () => { setOpen(false); hamburger.focus(); });
    // close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('open')) setOpen(false);
    });
  }

  // ---- scroll reveal ----
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('in'));
  }

  // ---- generic .acc-item accordion (used by some content pages) ----
  document.querySelectorAll('.acc-item .acc-q').forEach((q) => {
    q.addEventListener('click', () => {
      const item = q.closest('.acc-item');
      if (item) item.classList.toggle('open');
    });
  });

  // ---- PDP-style accordion (.acc + .acc-h header + .acc-c content) ----
  // The whole .acc element toggles the open class; .acc-c uses max-height for
  // a smooth open animation. Each .acc renders independently — no exclusive
  // open behaviour (matches the product-page reference).
  document.querySelectorAll('.acc > .acc-h').forEach((h) => {
    h.addEventListener('click', () => {
      const acc = h.parentElement;
      if (!acc) return;
      const isOpen = acc.classList.contains('open');
      acc.classList.toggle('open');
      const content = acc.querySelector('.acc-c');
      if (content) content.style.maxHeight = isOpen ? null : content.scrollHeight + 'px';
    });
  });

  // ---- FAQ accordion (.faq + .faq-q / .faq-a — sets max-height for smooth open) ----
  document.querySelectorAll('.faq-q').forEach((q) => {
    q.addEventListener('click', () => {
      const item = q.closest('.faq-item');
      if (!item) return;
      const isOpen = item.classList.contains('open');
      item.classList.toggle('open');
      const answer = item.querySelector('.faq-a');
      if (answer) {
        answer.style.maxHeight = isOpen ? null : answer.scrollHeight + 'px';
      }
    });
  });

  // ---- product page: once-off vs subscribe toggle ----
  // Each .buy-opt radio carries `data-price` and `data-cta`. Selecting one updates
  // the visible price and CTA label. Bind to subscription selling plans in Liquid.
  const buyOpts = document.querySelectorAll('.buy-opt');
  const priceEl = document.querySelector('[data-price-display]');
  const ctaEl = document.querySelector('[data-cta-display]');
  buyOpts.forEach((opt) => {
    opt.addEventListener('change', () => {
      if (!opt.checked) return;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (ctaEl && opt.dataset.cta) ctaEl.textContent = opt.dataset.cta;
    });
  });

  // ---- Payfast subscribe toggle: highlight the chosen card + swap the CTA label ----
  const pfCta = document.querySelector('[data-pf-cta]');
  if (pfCta && !pfCta.dataset.sub) pfCta.dataset.sub = pfCta.textContent;
  document.querySelectorAll('input[name="pf_subscribe"]').forEach((r) => {
    r.addEventListener('change', () => {
      const group = r.closest('.buy-opt');
      if (group) group.querySelectorAll('.opt').forEach((o) => o.classList.toggle('sel', o.contains(r)));
      if (pfCta) pfCta.textContent = r.value === '1' ? pfCta.dataset.sub : 'Add to cart';
    });
  });

  // ---- qty stepper (product page) ----
  document.querySelectorAll('.qty').forEach((qty) => {
    const input = qty.querySelector('input[type=number]');
    const minus = qty.querySelector('[data-qty-minus]');
    const plus = qty.querySelector('[data-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    plus && plus.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
})();
